import React from 'react'
// import { useGlobalContext } from '../context'

const SearchForm = ({ selectedCards, setSelectedCards }) => {
  // const { cards } = useGlobalContext();

  const searchValue = React.useRef('');

  React.useEffect(() => {
    searchValue.current.focus();
  }, []);

  function searchCards() {
    // //setSearchTerm(searchValue.current.value);
    // if(selectedCards.length === 0){
    //   selectedCards = [...cards];
    // }
    // if (!searchValue.current.value) {
    //   selectedCards = [...cards];
    // }

    // console.log(searchValue.current.value);
    // selectedCards = selectedCards.filter((item) => item.name.includes(searchValue.current.value))
    // //Not working after backspace because selectedCards has a value
    // console.log(selectedCards)
  }

  function handleSubmit(e) {
    e.preventDefault();
  }

  return (
    <section className="section search">
      <form className="search-form" onSubmit={handleSubmit}>
        <div className="form-control">
          <input
            type="text"
            id="maxcrystals"
            placeholder="Search name, ability, etc..."
            ref={searchValue}
            onChange={searchCards}
          />
        </div>
      </form>
    </section>
  );
};

export default SearchForm
